import { redirect } from "react-router";

import { msalInstance } from "../config/msalConfig";
import { routes } from "../config/routes";
import { getAccessToken } from "./SecurityManager";

export const authenticatedRouteLoader = () => {
    // eslint-disable-next-line no-underscore-dangle
    const isMSEntraLogin = window.__RUNTIME_CONFIG__?.IDENTITY_SERVICE === "entra";
    const accessToken = getAccessToken();

    if (!isMSEntraLogin) {
        if (!accessToken) {
            return redirect(routes.login.path);
        }
        return null;
    }

    const isMsalProcessing = msalInstance.getAllAccounts().length === 0;

    if (!accessToken && !isMsalProcessing) {
        return redirect(routes.login.path);
    }

    return null;
};
